/**
 * Whether PostHog may capture on this host: a project key, and not localhost
 * unless local analytics are switched on. Shared by the browser client's init
 * and the chunk-outage beacon (#6168), so both make the same decision.
 * Pure and dependency-free: the beacon must not pull in posthog-js.
 */
export function isPostHogCaptureAllowed(args: {
  apiKey: string | undefined;
  hostname: string | undefined;
  enableLocalAnalytics: boolean;
}): boolean {
  const isLocalhost =
    args.hostname === 'localhost' ||
    args.hostname === '127.0.0.1' ||
    args.hostname === '::1';
  return (
    typeof args.apiKey === 'string' &&
    args.apiKey.length > 0 &&
    (!isLocalhost || args.enableLocalAnalytics)
  );
}
